import withResponsiveHOC from "components/enhancements/responsive-hoc/responsive-hoc-component";
import WhatsNewPageLayoutDesktopComponent from "./desktop/whats-new-page-layout-desktop-component";
import WhatsNewPageLayoutMobileComponent from "./mobile/whats-new-page-layout-mobile-component";
const WhatsNewPageLayoutComponent = withResponsiveHOC(WhatsNewPageLayoutDesktopComponent, WhatsNewPageLayoutMobileComponent);
export default WhatsNewPageLayoutComponent;
